import { LitElement, html } from 'lit';

import translate from '../../utils/webcomponents/translate';

class UnderlyingOverviewFilters extends LitElement {
	static get properties() {
		return {
			filters: { type: Array },
		};
	}

	get searchParams() {
		return new URLSearchParams(window.location.search);
	}

	render() {
		const filters = this.renderFilters();
		const labelClear = translate('alphabeticalunderlyings', 'clearFilters', 'Clear filters');

		return html`
			<div class="form__row">
				${filters}
				<div class="form__row-section form__row-section--end form__row-section--shrink">
					<div class="field">
						<button
							type="reset"
							class="button button--inverted ${this.filters.length ? '' : 'is-hidden'}"
							?disabled=${this.isResetDisabled()}
						>
							${labelClear}
						</button>
					</div>
				</div>
			</div>
		`;
	}

	renderFilters() {
		const labelAll = translate('alphabeticalunderlyings', 'all', 'All');

		return this.filters.map(
			(filter) => html`
				<div class="form__row-section">
					<div class="field">
						<label class="field__label">${filter.label}</label>
						<select
							name="${filter.name}"
							class="field__input"
						>
							<option value="">${labelAll}</option>
							${filter.options.map((option) => this.renderFilterOption(filter, option))}
						</select>
					</div>
				</div>
			`,
		);
	}

	renderFilterOption(filter, option) {
		return html`
			<option
				value="${option.value}"
				?selected=${this.isSelected(filter.name, option.value)}
				?disabled=${!option.isDisplayed}
			>
				${option.label}
			</option>
		`;
	}

	isResetDisabled() {
		const { searchParams } = this;
		const values = Array.from(searchParams.values());

		return values.every((v) => !v);
	}

	isSelected(filter, value) {
		return this.searchParams.get(filter) === value;
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-underlying-overview-filters', UnderlyingOverviewFilters);

export default UnderlyingOverviewFilters;

